const edit = [
  {
    path: '/editBanner',
    name: 'editBanner',
    component: () => import('@/components/Edit/editBanner'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/wxNewsMessage',
    name: 'wxNewsMessage',
    component: () => import('@/components/Wx/wxNewsMessage.vue'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/contentShow',
    name: 'contentShow',
    component: () => import('@/components/Edit/contentShow.vue'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/editTree',
    name: 'editTree',
    component: () => import('@/components/Edit/editTree.vue'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/editNews',
    name: 'editNews',
    component: () => import('@/components/Edit/editNews.vue'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/editSeo',
    name: 'editSeo',
    component: () => import('@/components/Edit/editSeo.vue'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  }
]

export default edit
